import {Button, Paper} from "@mui/material";
import {useNavigate} from "react-router";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Assignment} from "@mui/icons-material";


export const ProdutosIndexPage = () => {
    const navigate = useNavigate()

    return (<DefaultContainer titulo={'Produtos'}
                              size={'medium'}
                              component={Paper}>
            <Button endIcon={<Assignment/>}
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate('/produtos/consulta')}
                    fullWidth>
                Gerenciar Produtos
            </Button>
        </DefaultContainer>
    );
}